import { render } from "preact";
import { App } from "./App";
import { loadInitialPuzzle } from "./game/state";
import "./styles/index.css";
import { watchSystemTheme } from "./theme";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");
watchSystemTheme();

// Boot order: dev install → puzzle load → first render. The dev
// install registers the dev-mode-aware puzzle loader on the state
// machine BEFORE loadInitialPuzzle runs, so dev-mode panels get
// to override the live-API path on the very first call. In
// production builds, `import.meta.env.DEV` folds to the literal
// `false`, the surrounding branch becomes dead code, and the
// dynamic import target is unreachable to the bundler — exactly
// the contract in briefs/dev-mode.md §"Gate pattern".
async function boot(): Promise<void> {
  if (import.meta.env.DEV) {
    const m = await import("./dev/install");
    await m.installDevMode();
  }
  await loadInitialPuzzle();
  render(<App />, root!);
}

void boot();
